import React, { Component } from "react";
import Lottie from "react-lottie";
import styles from "./styles";
import phoneAnimation from "../../animationsAE/lmc_page.json";

class LmcPhone extends Component {
  render() {
    const { appContainerStyle, lmcAnimationMaskStyle } = styles;
    return (
      <div style={appContainerStyle}>
        <div
          style={{
            marginTop: 10,
            paddingTop: 20,
            paddingBottom: 20,
          }}
        >
          <div style={lmcAnimationMaskStyle}>
            <Lottie options={{ animationData: phoneAnimation, loop: true }} />
          </div>
        </div>
      </div>
    );
  }
}

export default LmcPhone;
